import React, { Component } from 'react';

import Login from './components/Login';
import AdminPanel from './components/AdminPanel';
import List from './components/List';
import Profile from './components/Profile';
import Test from './components/Tests';
import Statuses from './components/Statuses';
import NotFound from './../../components/NotFound';

import { Link } from 'react-router'

function setCookie(name, value, options) {
  options = options || {};

  var expires = options.expires;

  if (typeof expires == "number" && expires) {
    var d = new Date();
    d.setTime(d.getTime() + expires * 1000);
    expires = options.expires = d;
  }
  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString();
  }

  value = encodeURIComponent(value);

  var updatedCookie = name + "=" + value;

  for (var propName in options) {
    updatedCookie += "; " + propName;
    var propValue = options[propName];
    if (propValue !== true) {
      updatedCookie += "=" + propValue;
    }
  }

  document.cookie = updatedCookie;
}

var AppAdmin = React.createClass({
  getInitialState: function(){
    props.error = false;
    return props;
  },
  handlerCheckLogin: function(data){
    var THIS = this;

    if (typeof this.props.params.profile != 'undefined') {
      data.profile = this.props.params.profile;
    }
    if (typeof this.props.params.specialty != 'undefined') {
      data.specialty = this.props.params.specialty;
    }

    io.socket.post("/api/checkLogin", data, function (response){

      setCookie('login', data.login, {expires: 2592000000, path: '/'});
      setCookie('pass', data.pass, {expires: 2592000000, path: '/'});

      THIS.setState(response);
    });
  },
  handlerReloadUsers: function(data){
    this.setState({
      users: data
    });
  },
  handlerReloadSpecialties: function(data){
    console.log('handlerReloadSpecialties', data)
    this.setState({
      specialties: data
    });
  },
  handlerChangeStatus: function(status, history, new1Cstatus){

    var specialties = this.state.specialties;
    specialties[this.state.idSpecialty].profiles[this.state.idProfile].status = status;
    if(new1Cstatus){
      specialties[this.state.idSpecialty].profiles[this.state.idProfile].status1C = new1Cstatus;
    }
    specialties[this.state.idSpecialty].profiles[this.state.idProfile].historyStatus = history;
    // console.log('specialties', specialties)
    this.setState({specialties: specialties});
  },
  componentWillReceiveProps: function(nextProps){
    var THIS = this;
    if(this.props.params.specialty != nextProps.params.specialty && typeof nextProps.params.specialty != 'undefined'){
      var specialties = this.state.specialties;
      io.socket.post("/api/getProfileOfSpecialty", {specialty: nextProps.params.specialty, login: this.state.login, pass: this.state.pass}, function (response){
        for(var i = 0, l = specialties.length; i < l; i++){
          if(nextProps.params.specialty == specialties[i].id){
            specialties[i].profiles = response.profiles;
            THIS.setState({
              specialties: specialties,
              notFoundSpecialty: false,
              idSpecialty: i
            });
          }
        }
      });
    }
    if(this.props.params.profile != nextProps.params.profile && typeof nextProps.params.profile != 'undefined'){
      var profiles = this.state.specialties[this.state.idSpecialty].profiles;
      for(var i = 0, l = profiles.length; i < l; i++){
        if(profiles[i].id == nextProps.params.profile){
          this.setState({
            idProfile: i,
            notFoundProfile: false
          })
        }
      }
    }
  },
  exit: function(){
    setCookie('login', '', {expires: 2592000000, path: '/'});
    setCookie('pass', '', {expires: 2592000000, path: '/'});
    this.setState({auth: false, admin: false})
  },
  findByPhone: function(){
    io.socket.post("/api/findFromAdmin", {phone: this.state.findByPhone}, function (response){
      console.log(response)
      window.location.href = response.link;
    })
  },
  // componentDidMount(){
  //   document.querySelectorAll('jdiv').forEach(function(item){console.log(item)})
  // },
  render: function(){
    if (this.state.auth){
      if (this.state.admin) {
        return(
          <div className="AppAdmin">
              <AdminPanel
                users={this.state.users}
                actionReloadUsers={this.handlerReloadUsers}
                login={this.state.login}
                pass={this.state.pass}
                specialties={this.state.specialties}
                exit={this.exit}
                handlerReloadSpecialties={this.handlerReloadSpecialties}
              />
          </div>
        );
      }else{
        if(this.props.route.test == true){
          return(
          <div className="AppAdmin">
            <Test profile={this.state.specialties[this.state.idSpecialty].profiles[this.state.idProfile]} specialty={this.props.params.specialty}/>
          </div>
          );
        }else if(this.props.route.statuses == true){
          return(
          <div className="AppAdmin">
            <Statuses profile={this.state.specialties[this.state.idSpecialty].profiles[this.state.idProfile]} specialty={this.props.params.specialty}/>
          </div>
          );
        }else if(this.props.route.path == "/admin/ref/"){
          console.log('ref')
          return(
            <div className="AppAdmin">
                <Link to={'/admin/'} className="SelectSpecialtiesOpen top">Назад</Link>
                <div className="UserList">
                  <div className="User RefLink" style={{textAlign: 'left'}}>
                    <div className="name"><div style={{fontSize: 14, color: '#696969', marginBottom: 5}}>Ваша ссылка:</div> https://ibot.pro/ref/{this.state.userID}</div>
                    <div style={{right: -1, display: 'flex', alignItems: 'center'}} className="change" onClick={()=>{
                      navigator.clipboard.writeText('https://ibot.pro/ref/' + this.state.userID)
                      .then(() => {
                        // Получилось!
                      })
                      .catch(err => {
                        console.log('Something went wrong', err);
                      });
                    }}>Скопировать</div>
                  </div>
                </div>
                <div class="headlineWrapper"><div class="headline">Ваши пользователи ({this.state.ref.length})</div></div>
                {this.state.ref.map((profile, i) => {

                  var status = profile.status,
                  statusText = '';

                  if(status === true || status === 'true' || status === 1 || status === '1'){
                    status = true;
                    statusText = 'Принят';
                  }else if(status === false || status == 'false' || status === 2 || status === '2'){
                    status = false;
                    statusText = 'Отказ';
                  }else if(status === 3 || status === '3'){
                    status = 3;
                    statusText = 'Работает';
                  }else if(status === 4 || status === '4'){
                    status = 4;
                    statusText = 'Уволен';
                  }else{
                    status = 0;
                    statusText = 'На расмотрении';
                  }
              
                  return(
                    <div key={i} className="SelectSpecialtiesOpen" style={{display: 'block', textAlign: 'left'}}>
                      <div style={{fontSize: 10, color: '#ccc', marginTop: 5}}>Имя</div>
                      <div>{profile.firstName}</div>
                      <div style={{fontSize: 10, color: '#ccc', marginTop: 5}}>Фамилия</div>
                      <div>{profile.secondtName}</div>
                      {profile.numberPhone ? (
                        <div>
                          <div style={{fontSize: 10, color: '#ccc', marginTop: 5}}>Телефон</div>
                          <div>{profile.numberPhone}</div>
                        </div>
                      ) : null}
                      <div style={{fontSize: 10, color: '#ccc', marginTop: 5}}>Узнал из</div>
                      <div>{profile.infoAbout}</div>
                      <div style={{fontSize: 10, color: '#ccc', marginTop: 5}}>Специальность</div>
                      <div>{profile.specialty}</div>
                      <div style={{fontSize: 10, color: '#ccc', marginTop: 5}}>Статус трудоустройства</div>
                      <div>{statusText}</div>
                    </div>
                  
                  );
                  

                })}
            </div>
            
          )
        }else if(this.props.params.profile){
          if(this.state.notFoundSpecialty){
            return (
              <NotFound
                name="СПЕЦИАЛЬНОСТЬ НЕ НАЙДЕНА"
                nameButton="Другие специальности"
                link={"/admin/"}
              />
            )
          }else if(this.state.notFoundProfile){
            return (
              <NotFound
                name="ПРОФАЙЛ НЕ НАЙДЕН"
                nameButton="Другие профайлы"
                link={"/admin/specialty/" + this.props.params.specialty + "/"}
              />
            )
          }else if(typeof this.state.idProfile != 'undefined'){
            return(
              <div className="AppAdmin">
                <Profile
                  failureStatuses={this.state.failureStatuses}
                  profile={this.state.specialties[this.state.idSpecialty].profiles[this.state.idProfile]}
                  actionChangeStatus={this.handlerChangeStatus}
                  location={this.props.location.pathname}
                  specialty={this.props.params.specialty}
                  login={this.state.login}
                  pass={this.state.pass}
                />
              </div>
            );
          }else{
            return(<div className="AppAdmin"><div className="loading"></div></div>);
          }

        }else if(this.props.params.specialty){
          if(this.state.notFoundSpecialty){
            return (
              <NotFound
                name="CПЕЦИАЛЬНОСТь НЕ НАЙДЕНА"
                nameButton="Другие специальности"
                link={"/admin/"}
              />
            )
          }else if(typeof this.state.idSpecialty != 'undefined'){
            return(
              <div className="AppAdmin">
                <List
                  profiles={this.state.specialties[this.state.idSpecialty].profiles}
                  specialty={this.props.params.specialty}
                />
              </div>
            );
          }else{
            return(<div className="AppAdmin"><div className="loading"></div></div>);
          }

        }else{
          var oldSpecialties = [],
              newSpecialties = [];
          
          this.state.specialties.map(item => {
            if(item.old){
              oldSpecialties.push(item)
            }else{
              newSpecialties.push(item)
            }
          })
          return(
            <div className="AppAdmin">
              <div className="SelectSpecialtiesOpen top" onClick={this.exit}>Выйти</div>
              <Link to={'/admin/ref/'} className="SelectSpecialtiesOpen top">Реферальная система</Link>
              <div className="LoginForm" style={{position: 'relative'}}>
                  <input style={{textAlign: 'left', paddingLeft: 15, width: 'calc(100% - 15px)'}} type="text" autoCapitalize="none" onChange={(e)=>{
                    this.setState({findByPhone: e.target.value})
                  }} placeholder="Найти по номеру" value={this.state.findByPhone} name="login" />
                  <div onClick={this.findByPhone} style={{position: 'absolute', right: 5, top: 6, background: '#5454ff', height: 40, width: 50, textAlign: 'center', cursor: 'pointer', borderRadius: 5, lineHeight: '40px', color: '#fff'}}>Ок</div>
              </div>
              {newSpecialties.length ? (
                <div>
                  <div class="headlineWrapper"><div class="headline">Специальности ({newSpecialties.length})</div></div>
                  <List
                    specialties={newSpecialties}
                  />
                </div>
              ) : null}
              {oldSpecialties.length ? (
                <div>
                  <div class="headlineWrapper"><div class="headline">Старые специальности ({oldSpecialties.length})</div></div>
                  <List
                    specialties={oldSpecialties}
                  />
                </div>
              ) : null}
            </div>
          );
        }
      }

    }else{
      return(
        <div className="AppAdmin">
          <div className="table-cell">
            <Login
              actionCheckLogin={this.handlerCheckLogin}
              error={this.state.error}
            />
          </div>
        </div>
      );
    }

  }
});

export default AppAdmin;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/index.jsx
 **/